import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import Skeleton from 'components/Skeleton';

import * as S from './styled';

const CopyCodeDesktop = ({ accessCode, isLoading }: { accessCode?: string; isLoading: boolean }) => {
    const { t } = useTranslation();
    const formattedAccessCode = accessCode && accessCode.split('').map((ch, i) => <span key={i}>{ch}</span>);

    return (
        <S.DesktopLoginWrapper>
            <Text type="large-text" bold mb={16} center>
                {t('main.step.copyCode.mobile.title')}
            </Text>
            <Text type="caption" bold mb={4} center color="text-secondary-subdued">
                {t('main.step.copyCode.desktop.accessCode')}
            </Text>
            {isLoading ? (
                <Skeleton height={58} mb={4} />
            ) : (
                <S.AccessCode bold center dataLocator="accessCode">
                    {formattedAccessCode}
                </S.AccessCode>
            )}
            <Text type="caption" bold center color="text-secondary-subdued">
                {t('main.step.copyCode.codeValidity')}
            </Text>
        </S.DesktopLoginWrapper>
    );
};

export default CopyCodeDesktop;
